import { render, staticRenderFns } from "./QywxGuide.vue?vue&type=template&id=3cfe4e5f&scoped=true&"
import script from "./QywxGuide.vue?vue&type=script&lang=js&"
export * from "./QywxGuide.vue?vue&type=script&lang=js&"
import style0 from "./QywxGuide.vue?vue&type=style&index=0&id=3cfe4e5f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfe4e5f",
  null
  
)

export default component.exports